import { createFeatureSelector, createSelector } from '@ngrx/store';import { RevistaState } from './revista.reducers';
import * as fromRevista from './revista.reducers';

export const revistaState = createFeatureSelector<RevistaState>("revista");

export const allRevista = createSelector(
	revistaState,
	fromRevista.selectAll
);

export const revistaReady = createSelector(
	revistaState,
	state => state.ready	
);

export const revistaMorePagesToLoad = createSelector(
	revistaState,
	state => state.morePagesToLoad
);

export const revistaNextPageNum = createSelector(
	revistaState,
	state => state.nextPageNum
);

export const revistaPageSize = createSelector(
	revistaState,
	state => state.pageSize
);

export const revistaStatus = createSelector(
	revistaState,
	state => state.status	
);


export const revistaCleared = createSelector(
	revistaState,
	state => state.cleared
)